<div class="loader-container" [ngClass]="{ 'extra-small-loader': extraSmallLoader, 'full-loader': fullLoader }">
    <div class="loader">
        <div class="loader-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
</div>
